import { Box, Divider, List, Paper } from '@mui/material';
import { FieldValues, FormProvider, SubmitHandler, useFormContext } from 'react-hook-form';
import { HiOutlineBanknotes } from 'react-icons/hi2';
import { LuBookOpenCheck, LuFileClock, LuLanguages, LuMap, LuSearch } from 'react-icons/lu';
import { WsColors, WsSelect } from 'wisestep-base';

import { WsAccordion } from '../../../../components/filters/components';
import AdvancedFiltersHeader from '../../../../utils/AdvancedFiltersHeader';
import BasicSearchForm from '../../types/IBasicSearchForm';
import ICVLibraryAdvanceSearch from '../types/ICVLibraryAdvanceSearch';
import {
  industryOptions,
  languageOptions,
  minMatchOptions,
  relocationOptions,
  salaryOptions,
  searchNameOnlyOptions,
  stemPhrasesOptions,
  tempPermOptions,
} from '../utils/CVLibraryHelper';

interface AdvanceFilterNewProps {
  performSearch: (values: BasicSearchForm & ICVLibraryAdvanceSearch) => void;
}
const AdvancedFiltersNew = ({ performSearch }: AdvanceFilterNewProps) => {
  const methods = useFormContext();
  const { handleSubmit, reset } = methods;
  return (
    <FormProvider {...methods}>
      <Paper sx={{ mt: 2 }}>
        <Box
          component="form"
          role="presentation"
          onSubmit={handleSubmit(performSearch as SubmitHandler<FieldValues>)}
          onReset={() => reset()}
        >
          <AdvancedFiltersHeader />
          <Divider />
          <List>
            <WsAccordion
              title="Stem Phrases"
              startIcon={<LuSearch color={WsColors.TertiaryShades800} />}
            >
              <WsSelect name="stemPhrases" selectArray={stemPhrasesOptions} placeholder="Select" />
            </WsAccordion>

            <WsAccordion
              title="Search Name Only"
              startIcon={<LuSearch color={WsColors.TertiaryShades800} />}
            >
              <WsSelect
                name="searchNameOnly"
                selectArray={searchNameOnlyOptions}
                placeholder="Select"
              />
            </WsAccordion>

            <WsAccordion
              title="Willing to Relocate"
              startIcon={<LuMap color={WsColors.TertiaryShades800} />}
            >
              <WsSelect name="relocation" selectArray={relocationOptions} placeholder="Select" />
            </WsAccordion>

            <WsAccordion
              title="Search Salary"
              startIcon={<HiOutlineBanknotes color={WsColors.TertiaryShades800} />}
            >
              <WsSelect name="salary" selectArray={salaryOptions} placeholder="Select" />
            </WsAccordion>
            <WsAccordion
              title="Industry"
              startIcon={<LuBookOpenCheck color={WsColors.TertiaryShades800} />}
            >
              <WsSelect name="industry" selectArray={industryOptions} label="Select" />
            </WsAccordion>

            <WsAccordion
              title="Language"
              startIcon={<LuLanguages color={WsColors.TertiaryShades800} />}
            >
              <WsSelect name="language" selectArray={languageOptions} placeholder="Select" />
            </WsAccordion>

            <WsAccordion
              title="Category"
              startIcon={<LuFileClock color={WsColors.TertiaryShades800} />}
            >
              <WsSelect name="tempPerm" selectArray={tempPermOptions} placeholder="Select" />
            </WsAccordion>

            <WsAccordion
              title="Minimum Matching"
              startIcon={<LuSearch color={WsColors.TertiaryShades800} />}
            >
              <WsSelect name="minMatch" selectArray={minMatchOptions} placeholder="Select" />
            </WsAccordion>
          </List>
        </Box>
      </Paper>
    </FormProvider>
  );
};

export default AdvancedFiltersNew;
